(ns frontend.ui.component.lp-portal.report.body.innovestor.fund.pdf.pages.investor-information
  (:require
   [frontend.ui.component.lp-portal.page.pdf.view :as page]
   [frontend.ui.component.lp-portal.report.body.voima.fund.pdf-pages.fund-overview :refer [empty-table-data?]]
   [frontend.ui.component.lp-portal.report.component.horizontal-table.pdf-view :as horizontal-table-pdf]
   [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]))

(defn capital-account-ytd-table
  [data]
  (let [remove-page? (empty-table-data? (:fund-status data) :capital-account-year-to-date)]
    (when-not remove-page?
      (page/page
       (page/page-title-with-line {:fund-name  (:fund-name data)
                                   :page-title "Investor information - Capital account YTD"
                                   :toc-item   true
                                   :reporting-period (:reporting-period data)})
       (horizontal-table-pdf/table (->> data
                                        :fund-status
                                        :capital-account-year-to-date))
       (text-content/optional-footer (->> data
                                          :fund-status
                                          :capital-account-year-to-date))))))

(defn capital-account-since-inception-table
  [data]
  (let [remove-page? (empty-table-data? (:fund-status data) :capital-account-since-inception)]
    (when-not remove-page?
      (page/page
       (page/page-title-with-line {:fund-name  (:fund-name data)
                                   :page-title "Investor information - Capital account since inception"
                                   :toc-item   true
                                   :reporting-period (:reporting-period data)})
       (horizontal-table-pdf/table (->> data
                                        :fund-status
                                        :capital-account-since-inception))
       (text-content/optional-footer (->> data
                                          :fund-status
                                          :capital-account-since-inception))))))

(defn investor-information-pages
  [data]
  [(capital-account-since-inception-table data)
   (capital-account-ytd-table data)])
